export default {
      id: "iddaaa_logo-usage",
      viewBox: "0 0 97 28",
      url: "/" + "images/icons.3.109.2.svg#iddaaa_logo-usage",
      toString: function () {
        return this.url;
      }
    }